import { configureStore } from '@reduxjs/toolkit';
import themeReducer from './slices/themeSlice';
import authReducer from './slices/authSlice';
import passwordReducer from './slices/passwordSlice';
import templateReducer from './slices/templateSlice';
import vaultReducer from './slices/vaultSlice';
import vaultFolderReducer from './slices/vaultFolderSlice';
import vaultMemberReducer from './slices/vaultMemberSlice';
import userReducer from './slices/userSlice';
import { baseApi } from './api/baseApi';

export const store = configureStore({
  reducer: {
    theme: themeReducer,
    auth: authReducer,
    password: passwordReducer,
    template: templateReducer,
    vault: vaultReducer,
    vaultFolder: vaultFolderReducer,
    vaultMember: vaultMemberReducer,
    user: userReducer,
    [baseApi.reducerPath]: baseApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(baseApi.middleware),
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
